interface ZendeskWidget {
  (
    type: "messenger" | "messenger:on" | "messenger:get" | "messenger:set",
    command: string,
    payload?: unknown
  ): unknown;
  (
    type: "messenger:ui",
    command: string,
    payload?: unknown,
    callback?: (error?: unknown) => void
  ): unknown;
}

export type ZendeskAuthEventType =
  | "login_started"
  | "token_request"
  | "retry_scheduled"
  | "authenticated"
  | "token_refreshed"
  | "refresh_exhausted"
  | "recovery_started"
  | "recovered"
  | "logout";

export interface ZendeskAuthEvent {
  type: ZendeskAuthEventType;
  attempt?: number;
  delayMs?: number;
  phase?: "login" | "refresh";
  status?: number;
  trigger?: "install" | "explicit" | "online" | "open" | "visibility";
}

export interface ZendeskMessagingAuth {
  install(options: {
    src: string;
    fetchToken: () => Promise<string | undefined>;
    renewalEnabled: boolean;
  }): Promise<void>;
  installFromFinancasConfig(): Promise<void>;
  ensureAuthenticationAttempt(): Promise<void>;
  login(fetchToken?: () => Promise<string | undefined>): Promise<void>;
  logout(): void;
  subscribeAuthEvents(
    listener: (event: ZendeskAuthEvent) => void
  ): () => void;
}

export interface IWindowZendesk {
  F360ZendeskMessagingAuth?: ZendeskMessagingAuth;
  ZENDESK_KEY?: string;
  ZENDESK_KEY_CIELO?: string;
  zE: ZendeskWidget;
}

export function logoutZendeskMessaging(targetWindow: Window = window): void {
  const windowZendesk = targetWindow as unknown as IWindowZendesk;

  try {
    windowZendesk.F360ZendeskMessagingAuth?.logout();
  } catch (_) {
    console.error("Falha ao encerrar sessao do Zendesk durante logout");
  }
}
